export default __webpack_public_path__ + "static/imgWedding-4c6d8a70a77074dabf7199953201a801.webp";